import { useTranslation } from 'react-i18next';

import type { TutorDashboardReport } from '../../../types/tutorAi';
import { formatCount } from '../../../utils/format';
import { KpiCard, KpiSkeletonGrid } from '../../atoms/KpiCard';

/** Grid compartilhado entre a linha real e a de carregamento, para o layout não mudar. */
const GRID_CLASS = 'grid grid-cols-1 gap-mini sm:grid-cols-2 lg:grid-cols-3';

/** Quantidade de indicadores da linha — espelhada no estado de carregamento. */
const KPI_COUNT = 6;

export interface UsageKpiRowProps {
  readonly report: TutorDashboardReport;
  /** Exibe placeholders no lugar dos indicadores enquanto o período é consultado. */
  readonly isLoading: boolean;
}

/**
 * Linha de indicadores do dashboard: consumo total em destaque, seguido dos consumos
 * unitários e do volume de uso do período.
 */
export function UsageKpiRow({ report, isLoading }: UsageKpiRowProps) {
  const { t } = useTranslation('tutorAI');

  if (isLoading) {
    return <KpiSkeletonGrid gridClass={GRID_CLASS} count={KPI_COUNT} />;
  }

  return (
    <div className={GRID_CLASS}>
      <KpiCard
        label={t('usage.kpi.totalTokens')}
        value={formatCount(report.totalTokensUsed)}
        emphasis
      />
      <KpiCard
        label={t('usage.kpi.tokensPerStudent')}
        value={formatCount(Math.round(report.tokensPerStudent))}
      />
      <KpiCard
        label={t('usage.kpi.tokensPerConversation')}
        value={formatCount(Math.round(report.tokensPerConversation))}
      />
      <KpiCard
        label={t('usage.kpi.conversations')}
        value={formatCount(report.totalConversations)}
      />
      <KpiCard label={t('usage.kpi.messages')} value={formatCount(report.totalMessages)} />
      <KpiCard
        label={t('usage.kpi.activeStudents')}
        value={formatCount(report.totalStudentsWithConversations)}
      />
    </div>
  );
}
